exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "label[for=search][data-v-46c6f832]{color:#000;text-align:center;font-family:Montserrat;font-size:24px;font-style:normal;font-weight:600;line-height:normal;margin-bottom:1rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-46c6f832","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/app/components/hcxf/hcxf-practitioner-hub.vue
// module id = 577
// module chunks = 0 1